import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux';
import Loader from './components/shared/loader';
import { CookiebotUnivers } from './components/cookie/universCookiebot';
import { BrowserRouter } from 'react-router-dom';
import { isDesktop, isMobile } from 'react-device-detect';
import './configs/customTags';

//import './index.css'
import App from './app'
import store from './store';

isMobile && document.documentElement.classList.add('mobile');
isDesktop && document.documentElement.classList.add('desktop');

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <StrictMode>
      <Suspense fallback={<Loader />}>
        <CookiebotUnivers />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Suspense>
    </StrictMode>
  </Provider>
  ,
)
